import classNames from "classnames/bind";
import styles from './RegisterContainer.module.css';
import image from '../../../assets/images/Rectangle-5666.png';
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

function RegisterContainer({ children, verify }) {
    return (
        <div className={cx('register')}>
            <div className={cx('background')}>
                <img className={cx('background-image')} src={image} alt={'background'} />
            </div>
            <div className={cx('background-fill')}>
                <div className={cx('register-content', verify ? 'verify-container' : '')}>
                    {children}
                </div>
            </div>
        </div>
    )
}

RegisterContainer.propTypes = {
    children: PropTypes.node.isRequired,
    verify: PropTypes.bool
}

export default RegisterContainer;